import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getExcludeProfiles,
} from "../../../api/exludeClients/excludeClientService";

export const getExcludeProfilesThunk = createAsyncThunk(
  "excludeClient/getExcludeProfiles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getExcludeProfiles();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
